import type { GreaterArea } from '@/config/objects/greater-areas';
import { useOutletContext } from 'react-router-dom';

interface GreaterAreaContext {
  greaterArea: GreaterArea | undefined;
  isLoading: boolean;
}

export function useGreaterAreaContext() {
  return useOutletContext<GreaterAreaContext>();
}
